import {Grid, Typography} from '@mui/material';
import FeatureCard from './FeatureCard';
import {featureList} from './FeatureConfig';

export default function FeatureList() {
  return (
    <>
      <Typography variant="h1" component="h1" gutterBottom align="center">
        Powerful Features for Etsy Sellers
      </Typography>
      <Typography variant="h5" component="h2" gutterBottom align="center" color="text.secondary" sx={{mb: 6}}>
        Streamline your Etsy shop management and boost your sales with our innovative tools
      </Typography>
      <Grid container spacing={4}>
        {featureList.map((feature) => (
          <Grid size={{xs: 12, sm: 6, md: 4}} key={`FeatureList-${feature.title}`}>
            <FeatureCard {...feature} />
          </Grid>
        ))}
      </Grid>
    </>
  );
}
